import { cms } from '@/cms'
import { Component, Vue } from 'vue-property-decorator'

interface CountryItem {
  id: string
  label: string
}

@Component
export class TranslationHandler extends Vue {
  $t(id: string): string {
    return cms.i18n.t ? cms.i18n.t(id) : id
  }

  get $tLocales(): string[] {
    return cms.i18n.translations ? cms.i18n.translations.map((t) => t.locale.code) : ['de', 'en']
  }

  get $tLocaleCurrent(): string {
    return cms.i18n.currentLocale?.code || this.$tLocales[0]
  }

  $setLocale(locale: string) {
    cms.i18n.userPreferredLocale = locale
  }

  get $tCountries(): Record<string, string> {
    return cms.i18n.currentLocaleCountries
  }

  get $tCountriesItems(): CountryItem[] {
    return Object.entries(this.$tCountries).map(([k, v]) => ({ id: k, label: v })
    )
  }

  get $tCountryCurrent(): string|null {
    return cms.i18n.userGeo?.countryCode || null
  }
}
